<template>
  <div class="all-page-container">
    <div class="header">
      <div class="left">
        <img src="~@/assets/image/logo.png">
        <span>电梯安全公共信息服务平台</span>
      </div>
      <div class="right"><a-button type="primary" @click="close">关闭</a-button></div>
    </div>
    <div class="content">
      <div class="title-container">
        <div class="title">端子状态</div>
        <div class="desc">电梯内部编号：{{liftcode||''}}</div>
      </div>
      <div class="cards-container">
        <a-card class="card" title="电流/电压" :bordered="false">
          <a-row>
            <a-col :span="6">电流：<span v-text-color>{{detail['电流_电流']||''}}</span></a-col>
            <a-col :span="6">电压：<span v-text-color>{{detail['电流_电压']||''}}</span></a-col>
          </a-row>
        </a-card>
        <a-card class="card" title="主控板输入端子" :bordered="false">
          <a-row>
            <a-col :span="6">X1功能选择：<span v-text-color>{{detail['主控板输入_X1功能选择']||''}}</span></a-col>
            <a-col :span="6">X2功能选择：<span v-text-color>{{detail['主控板输入_X2功能选择']||''}}</span></a-col>
            <a-col :span="6">X3功能选择：<span v-text-color>{{detail['主控板输入_X3功能选择']||''}}</span></a-col>
            <a-col :span="6">X4功能选择：<span v-text-color>{{detail['主控板输入_X4功能选择']||''}}</span></a-col>
          </a-row>
          <a-row style="margin-top: 10px;">
            <a-col :span="6">X5功能选择：<span v-text-color>{{detail['主控板输入_X5功能选择']||''}}</span></a-col>
            <a-col :span="6">X6功能选择：<span v-text-color>{{detail['主控板输入_X6功能选择']||''}}</span></a-col>
            <a-col :span="6">X7功能选择：<span v-text-color>{{detail['主控板输入_X7功能选择']||''}}</span></a-col>
            <a-col :span="6">X8功能选择：<span v-text-color>{{detail['主控板输入_X8功能选择']||''}}</span></a-col>
          </a-row>
          <a-row style="margin-top: 10px;">
            <a-col :span="6">X9功能选择：<span v-text-color>{{detail['主控板输入_X9功能选择']||''}}</span></a-col>
            <a-col :span="6">X10功能选择：<span v-text-color>{{detail['主控板输入_X10功能选择']||''}}</span></a-col>
            <a-col :span="6">X11功能选择：<span v-text-color>{{detail['主控板输入_X11功能选择']||''}}</span></a-col>
            <a-col :span="6">X12功能选择：<span v-text-color>{{detail['主控板输入_X12功能选择']||''}}</span></a-col>
          </a-row>
          <a-row style="margin-top: 10px;">
            <a-col :span="6">X13功能选择：<span v-text-color>{{detail['主控板输入_X13功能选择']||''}}</span></a-col>
            <a-col :span="6">X14功能选择：<span v-text-color>{{detail['主控板输入_X14功能选择']||''}}</span></a-col>
            <a-col :span="6">X15功能选择：<span v-text-color>{{detail['主控板输入_X15功能选择']||''}}</span></a-col>
            <a-col :span="6">X16功能选择：<span v-text-color>{{detail['主控板输入_X16功能选择']||''}}</span></a-col>
          </a-row>
          <a-row style="margin-top: 10px;">
            <a-col :span="24">X17功能选择：<span v-text-color>{{detail['主控板输入_X17功能选择']||''}}</span></a-col>
          </a-row>
        </a-card>
        <a-card class="card" title="高压输入端子" :bordered="false">
          <a-row>
            <a-col :span="6">X25功能选择：<span v-text-color>{{detail['高压输入_X25功能选择']||''}}</span></a-col>
            <a-col :span="6">X26功能选择：<span v-text-color>{{detail['高压输入_X26功能选择']||''}}</span></a-col>
            <a-col :span="6">X27功能选择：<span v-text-color>{{detail['高压输入_X27功能选择']||''}}</span></a-col>
            <a-col :span="6">X28功能选择：<span v-text-color>{{detail['高压输入_X28功能选择']||''}}</span></a-col>
          </a-row>
        </a-card>
        <a-card class="card" title="主控板输出端子" :bordered="false">
          <a-row>
            <a-col :span="6">Y1功能选择：<span v-text-color>{{detail['主控板输出_Y1功能选择']||''}}</span></a-col>
            <a-col :span="6">Y2功能选择：<span v-text-color>{{detail['主控板输出_Y2功能选择']||''}}</span></a-col>
            <a-col :span="6">Y3功能选择：<span v-text-color>{{detail['主控板输出_Y3功能选择']||''}}</span></a-col>
            <a-col :span="6">Y4功能选择：<span v-text-color>{{detail['主控板输出_Y4功能选择']||''}}</span></a-col>
          </a-row>
        </a-card>
        <a-card class="card" title="轿顶输入状态" :bordered="false">
          <a-row>
            <a-col :span="6">系统光幕状态1：<span v-text-color>{{detail['轿顶输入_系统光幕状态1']||''}}</span></a-col>
            <a-col :span="6">系统光幕状态2：<span v-text-color>{{detail['轿顶输入_系统光幕状态2']||''}}</span></a-col>
            <a-col :span="6">门1开门限位：<span v-text-color>{{detail['轿顶输入_门1开门限位']||''}}</span></a-col>
            <a-col :span="6">门2开门限位：<span v-text-color>{{detail['轿顶输入_门2开门限位']||''}}</span></a-col>
          </a-row>
          <a-row style="margin-top: 10px;">
            <a-col :span="6">门1关门限位：<span v-text-color>{{detail['轿顶输入_门1关门限位']||''}}</span></a-col>
            <a-col :span="6">门2关门限位：<span v-text-color>{{detail['轿顶输入_门2关门限位']||''}}</span></a-col>
            <a-col :span="6">开关量称重3（满载）：<span v-text-color>{{detail['轿顶输入_开关量称重3（满载）']||''}}</span></a-col>
            <a-col :span="6">开关量称重4（超载）：<span v-text-color>{{detail['轿顶输入_开关量称重4（超载）']||''}}</span></a-col>
          </a-row>
        </a-card>
        <a-card class="card" title="轿顶输出状态" :bordered="false">
          <a-row>
            <a-col :span="6">开门输出1：<span v-text-color>{{detail['轿顶输出_开门输出1']||''}}</span></a-col>
            <a-col :span="6">关门输出1：<span v-text-color>{{detail['轿顶输出_关门输出1']||''}}</span></a-col>
            <a-col :span="6">门锁信号：<span v-text-color>{{detail['轿顶输出_门锁信号']||''}}</span></a-col>
            <a-col :span="6">开门输出2：<span v-text-color>{{detail['轿顶输出_开门输出2']||''}}</span></a-col>
          </a-row>
          <a-row style="margin-top: 10px;">
            <a-col :span="6">关门输出2：<span v-text-color>{{detail['轿顶输出_关门输出2']||''}}</span></a-col>
            <a-col :span="6">门锁信号：<span v-text-color>{{detail['轿顶输出_门锁信号']||''}}</span></a-col>
            <a-col :span="6">上到站钟标记：<span v-text-color>{{detail['轿顶输出_上到站钟标记']||''}}</span></a-col>
            <a-col :span="6">下到站钟标记：<span v-text-color>{{detail['轿顶输出_下到站钟标记']||''}}</span></a-col>
          </a-row>
          <a-row style="margin-top: 10px;">
            <a-col :span="6">开门按钮显示：<span v-text-color>{{detail['轿顶输出_开门按钮显示']||''}}</span></a-col>
            <a-col :span="6">关门按钮显示：<span v-text-color>{{detail['轿顶输出_关门按钮显示']||''}}</span></a-col>
            <a-col :span="6">开门延时按钮显示：<span v-text-color>{{detail['轿顶输出_开门延时按钮显示']||''}}</span></a-col>
            <a-col :span="6">直达标记：<span v-text-color>{{detail['轿顶输出_直达标记']||''}}</span></a-col>
          </a-row>
          <a-row style="margin-top: 10px;">
            <a-col :span="6">保留：<span v-text-color>{{detail['轿顶输出_保留']||''}}</span></a-col>
            <a-col :span="6">蜂鸣器输出：<span v-text-color>{{detail['轿顶输出_蜂鸣器输出']||''}}</span></a-col>
            <a-col :span="6">保留：<span v-text-color>{{detail['轿顶输出_保留']||''}}</span></a-col>
            <a-col :span="6">节能标记：<span v-text-color>{{detail['轿顶输出_节能标记']||''}}</span></a-col>
          </a-row>
        </a-card>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
  directives: {
    'text-color': {
      inserted(el) {
        if(el.innerHTML == '有效') {
          el.style.color = '#f81d22';
        }else {
          el.style.color = '#666';
        }
      },
      update(el) {
        // console.log(el)
        if(el.innerHTML == '有效') {
          el.style.color = '#f81d22';
        }else {
          el.style.color = '#666';
        }
      }
    }
  },
  props: ['liftnum', 'liftcode', 'devicenum'],
  data() {
    return {
      detail: {}
    }
  },
  computed: {
    ...mapState({
      socketMessage: state => state.socketMessage
    })
  },
  watch: {
    socketMessage(val) {
      if(val) {
        // {"data":{"主控板输入_X15功能选择":"有效","轿顶输入_门1关门限位":"无效","轿顶输出_关门输出1":"无效","轿顶输出_关门输出2":"无效","电流_电压":"561.60V","主控板输入_X14功能选择":"无效","轿顶输入_门2关门限位":"有效","主控板输入_X5功能选择":"无效","主控板输入_X16功能选择":"有效","轿顶输出_节能标记":"无效","轿顶输出_开门按钮显示":"无效","主控板输入_X13功能选择":"无效","主控板输入_X4功能选择":"无效","轿顶输入_系统光幕状态2":"有效","主控板输入_X17功能选择":"有效","轿顶输入_系统光幕状态1":"无效","轿顶输入_门2开门限位":"有效","轿顶输出_上到站钟标记":"无效","主控板输入_X3功能选择":"有效","主控板输入_X1功能选择":"有效","3":"","轿顶输入_开关量称重4（超载）":"无效","轿顶输出_关门按钮显示":"无效","主控板输入_X2功能选择":"有效","轿顶输出_门锁信号":"无效","高压输入_X26功能选择":"有效","主控板输入_X10功能选择":"无效","主控板输入_X9功能选择":"无效","高压输入_X27功能选择":"无效","主控板输出_Y2功能选择":"无效","高压输入_X25功能选择":"无效","轿顶输出_保留":"无效","轿顶输出_蜂鸣器输出":"无效","轿顶输入_开关量称重3（满载）":"无效","轿顶输出_下到站钟标记":"无效","轿顶输出_直达标记":"无效","主控板输入_X8功能选择":"无效","轿顶输入_门1开门限位":"有效","主控板输出_Y1功能选择":"无效","轿顶输出_开门延时按钮显示":"无效","主控板输入_X7功能选择":"无效","轿顶输出_开门输出1":"无效","轿顶输出_开门输出2":"无效","主控板输入_X12功能选择":"无效","主控板输入_X6功能选择":"无效","主控板输出_Y4功能选择":"无效","主控板输入_X11功能选择":"无效","主控板输出_Y3功能选择":"无效","电流_电流":"0.02A"},"returnmsg":"ok","returncode":0}
        // console.log(val);
        if(val.type == '4') {
          this.packageDatas(val.data);
        }
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    packageDatas(data) {
      this.detail = data || {};
    }
  }
}
</script>
<style lang="scss" scoped>
.all-page-container {
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: #F0F2F5;
  overflow-y: auto;
}
.header {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  height: 50px;
  background: #fff;
  padding: 0 24px;
  box-shadow: 0px 1px 4px 0px rgba(0, 21, 41, 0.12);
}
.left {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  img {
    height: 30px;
  }
  span {
    display: inline-block;
    margin-left: 8px;
    font-size: 12px;
    white-space: nowrap;
  }
}
.right {
  display: flex;
  align-items: center;
}
.content {
  padding-top: 50px;
}
.title-container {
  padding: 24px 40px;
  background-color: white;
  .title {
    font-size: 17px;
  }
  .desc {
    font-size: 13px;
    color: #999;
  }
}
.cards-container {
  padding: 0 30px 24px 30px;
  overflow: hidden;
  .card {
    margin-top: 24px;
  }
}
</style>